import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import GroupsDashboardPage from './GroupsDashboard';
import GroupsErrorPage from './GroupsError';
import GroupsPage from './GroupsPage';
import GroupSuccessPage from './GroupSuccess';

const GroupsRoute: FuseRouteItemType[] = [
  {
    path: 'groups',
    element: <GroupsPage />,
    auth: null,
  },
  {
    path: 'groups/error',
    element: <GroupsErrorPage />,
    auth: null,
  },
  {
    path: 'groups/dashboard',
    element: <GroupsDashboardPage />,
    auth: null,
  },
  {
    path: 'groups/success',
    element: <GroupSuccessPage />,
    auth: null,
  },
];

export default GroupsRoute;
